/** Small, pure pieces of the claim wizard (ClaimWizard.tsx), kept here to be tested. */

export function isWalletAddress(s: string): boolean {
  return /^0x[0-9a-fA-F]{40}$/.test(s)
}

/** The form people compare with the top of their wallet app: 0x4dEA…748f. */
export function shortAddress(a: string): string {
  return `${a.slice(0, 6)}…${a.slice(-4)}`
}

/**
 * The site's guide, section for Telegram winners, in the Mini App's language.
 * The site's language switch calls Chinese `ch` (frontend/src/lib/legalLang.ts).
 */
export function guideUrl(lang: string): string {
  const l = lang.toLowerCase()
  const code = l.startsWith('zh')
    ? 'ch'
    : ['es', 'pt', 'ru'].find((c) => l.startsWith(c)) ?? 'en'
  return `https://hybridlotto.win/guide?lang=${code}#won-in-telegram`
}

/**
 * The words for a server refusal, as an i18n key; null when the code is not
 * known (then the server's own message is shown). Every one of these means
 * nothing was sent.
 */
export function errorKey(code: string | undefined): string | null {
  switch (code) {
    case 'warming_up':
    case 'claim_pending':
    case 'payout_in_progress':
      return 'claim.errWait'
    case 'rpc_unavailable':
    case 'custody_unknown':
    case 'gas_above_ceiling':
    case 'prize_wallet_short_usdc':
    case 'prize_wallet_short_gas':
    case 'prize_wallet_not_separate':
    case 'round_paused':
      return 'claim.errPaused'
    case 'max_attempts_reached':
      return 'claim.errAttempts'
    case 'claim_window_closed':
    case 'prize_forfeited':
      return 'claim.errExpired'
    case 'already_claimed':
      return 'claim.errPaid'
    case 'not_a_winner':
      return 'claim.errNoPrize'
    case 'address_invalid':
      return 'claim.rejected'
    case 'session_already_active':
      return 'claim.errSession'
    case 'test_not_confirmed':
      return 'claim.errTestPending'
    case 'test_failed':
      return 'claim.errTestFailed'
    case 'network':
    case 'timeout':
      return 'claim.errNetwork'
    default:
      return null
  }
}
